<template lang="pug">
v-container.mt-5.pb-8(:fluid="fluid")
  custom-title(:text="title", :class="`text-${titleAlign}`", type="page")
  v-divider.mb-4.mt-2.primary.pt-1.rounded-pill
  slot
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    titleAlign: {
      type: String,
      default: "left",
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    get: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.get.forEach((v) => this.$rest(v).get());
  },
  components: {
    CustomTitle,
  },
};
</script>
